import React from 'react';
export function Footer() {
  return <footer className="bg-black pt-20 pb-10 border-t border-white/10 px-4 sm:px-6 lg:px-8" data-id="element-105">
      <div className="max-w-7xl mx-auto" data-id="element-106">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-107">
          {/* Brand */}
          <div className="md:col-span-1" data-id="element-108">
            <div className="inline-flex flex-col items-center leading-none mb-6" data-id="element-109">
              <span className="text-2xl font-normal tracking-[0.4em] text-white pl-[0.4em]" data-id="element-110">
                VANTIX
              </span>
              <span className="text-[10px] font-normal tracking-[0.3em] text-white/90 border-t border-amber-400 pt-1.5 mt-1.5 w-full text-center pl-[0.3em]" data-id="element-111">
                CREDIT SOLUTIONS
              </span>
            </div>
            <p className="text-white/50 font-light leading-relaxed text-sm mb-6" data-id="element-112">
              Transformamos tu crédito y desbloqueamos tu acceso a
              financiamiento. Sistema probado, resultados garantizados.
            </p>
          </div>

          {/* Servicios */}
          <div data-id="element-113">
            <h3 className="text-white font-semibold mb-5 text-sm tracking-wide" data-id="element-114">
              Servicios
            </h3>
            <ul className="space-y-3" data-id="element-115">
              <li data-id="element-116">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-117">
                  Reparación de Crédito
                </a>
              </li>
              <li data-id="element-118">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-119">
                  Optimización de Perfil
                </a>
              </li>
              <li data-id="element-120">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-121">
                  Fondeo Empresarial
                </a>
              </li>
              <li data-id="element-122">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-123">
                  Asesoría Personalizada
                </a>
              </li>
            </ul>
          </div>

          {/* Compañía */}
          <div data-id="element-124">
            <h3 className="text-white font-semibold mb-5 text-sm tracking-wide" data-id="element-125">
              Compañía
            </h3>
            <ul className="space-y-3" data-id="element-126">
              <li data-id="element-127">
                <a href="#proceso" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-128">
                  Nuestro Proceso
                </a>
              </li>
              <li data-id="element-129">
                <a href="#resultados" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-130">
                  Resultados
                </a>
              </li>
              <li data-id="element-131">
                <a href="#faq" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-132">
                  Preguntas Frecuentes
                </a>
              </li>
              <li data-id="element-133">
                <a href="#" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-134">
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Contacto */}
          <div data-id="element-135">
            <h3 className="text-white font-semibold mb-5 text-sm tracking-wide" data-id="element-136">
              Contacto
            </h3>
            <ul className="space-y-3" data-id="element-137">
              <li data-id="element-138">
                <a href="tel:+14073678672" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-139">
                  +1 (407) 367-8672
                </a>
              </li>
              <li data-id="element-140">
                <a href="mailto:eduardo@vantixcreditsolutions.com" className="text-white/50 hover:text-amber-400 transition-colors text-sm font-light" data-id="element-141">
                  eduardo@vantixcreditsolutions.com
                </a>
              </li>
              <li className="text-white/50 text-sm font-light" data-id="element-142">
                Miami · Houston · Los Angeles
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/40" data-id="element-143">
          <p data-id="element-144">
            © {new Date().getFullYear()} Vantix Credit Solutions. Todos los
            derechos reservados.
          </p>
          <div className="flex gap-6" data-id="element-145">
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-146">
              Privacidad
            </a>
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-147">
              Términos
            </a>
            <a href="#" className="hover:text-amber-400 transition-colors" data-id="element-148">
              Aviso Legal
            </a>
          </div>
        </div>
      </div>
    </footer>;
}